import React, { useRef, Fragment } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function BookExcerpts() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full bg-[#0a0a0a] py-28 px-6" data-id="element-34">
      <div className="max-w-4xl mx-auto" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-36">
          <p className="text-[#CF9B2E] uppercase tracking-[0.3em] text-sm font-bold mb-4 font-['Lato']" data-id="element-37">
            Fragmentos del libro
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#F5F0E8] mb-6" data-id="element-38">
            Palabras que no se olvidan
          </h2>
          <div className="gold-divider" data-id="element-39" />
        </motion.div>

        <div className="space-y-12" data-id="element-40">
          {/* Excerpt 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.1
        }} className="relative pl-8 border-l-2 border-[#C0392B]" data-id="element-41">
            <blockquote className="text-2xl md:text-3xl text-[#E8D5B0] leading-relaxed mb-4" data-id="element-42">
              "No fue la pobreza lo que nos rompió. Fue ver cómo la esperanza se
              apagaba en los ojos de quienes más amábamos."
            </blockquote>
            <cite className="text-[#9A9080] text-sm font-['Lato'] not-italic" data-id="element-43">
              — Capítulo III: El año en que todo cambió
            </cite>
          </motion.div>

          {/* Excerpt 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative pl-8 border-l-2 border-[#CF9B2E]" data-id="element-44">
            <blockquote className="text-2xl md:text-3xl text-[#E8D5B0] leading-relaxed mb-4" data-id="element-45">
              "Venezuela no murió. La enterraron viva. Y desde adentro del
              ataúd, su gente siguió gritando."
            </blockquote>
            <cite className="text-[#9A9080] text-sm font-['Lato'] not-italic" data-id="element-46">
              — Prólogo
            </cite>
          </motion.div>

          {/* Excerpt 3 */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="relative pl-8 border-l-2 border-[#1A5276]" data-id="element-47">
            <blockquote className="text-2xl md:text-3xl text-[#E8D5B0] leading-relaxed mb-4" data-id="element-48">
              "El exilio no es solo un lugar. Es una herida que sangra en
              silencio cada vez que alguien te pregunta de dónde eres."
            </blockquote>
            <cite className="text-[#9A9080] text-sm font-['Lato'] not-italic" data-id="element-49">
              — Capítulo VII: Los que se fueron
            </cite>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.8
      }} className="mt-16 text-center" data-id="element-50">
          <a href="#comprar" className="btn-primary inline-block px-10 py-4 text-base rounded-sm font-bold tracking-widest" data-id="element-51">
            Leer el libro completo — 9,99 USD
          </a>
        </motion.div>
      </div>
    </section>;
}